import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface StoreState {
  activeSection: string
  activeDepartment: string | null
  theme: 'dark' | 'light'
  soundEnabled: boolean
  sidebarOpen: boolean
  isBooted: boolean
  warpSpeed: boolean
  scrollDirection: number
  setActiveSection: (section: string) => void
  setActiveDepartment: (dept: string | null) => void
  toggleTheme: () => void
  toggleSound: () => void
  toggleSidebar: () => void
  setSidebarOpen: (isOpen: boolean) => void
  setBooted: (booted: boolean) => void
  setWarpSpeed: (active: boolean) => void
  triggerWarp: () => void
}

export const useStore = create<StoreState>()(
  persist(
    (set, get) => ({
      activeSection: 'home',
      activeDepartment: null,
      theme: 'light',
      soundEnabled: true,
      sidebarOpen: false,
      isBooted: false,
      warpSpeed: false,
      scrollDirection: 1,
      setActiveSection: (section) => {
        const order = ['home', 'work', 'about', 'projects', 'contact']
        const oldIdx = order.indexOf(get().activeSection)
        const newIdx = order.indexOf(section)
        const direction = newIdx > oldIdx ? 1 : newIdx < oldIdx ? -1 : get().scrollDirection || 1

        set({ activeSection: section, scrollDirection: direction, warpSpeed: true, activeDepartment: null })
        if (typeof window !== 'undefined') {
          const url = section === 'home' ? window.location.pathname + window.location.search : `#${section}`
          window.history.pushState(null, '', url)
        }
        setTimeout(() => {
          set({ warpSpeed: false })
        }, 1000)
      },
      setActiveDepartment: (dept) => set({ activeDepartment: dept }),
      toggleTheme: () => set((state) => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      toggleSound: () => set((state) => ({ soundEnabled: !state.soundEnabled })),
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarOpen: (isOpen) => set({ sidebarOpen: isOpen }),
      setBooted: (booted) => set({ isBooted: booted }),
      setWarpSpeed: (active) => set({ warpSpeed: active }),
      triggerWarp: () => {
        set({ warpSpeed: true })
        setTimeout(() => {
          set({ warpSpeed: false })
        }, 1000)
      },
    }),
    {
      name: 'corpix-store-v2',
      partialize: (state) => ({ theme: state.theme, soundEnabled: state.soundEnabled, isBooted: state.isBooted }),
    }
  )
)
